module.exports = __webpack_public_path__ + "static/img/2-8.2167d8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-2/2-8.jpg
// module id = 735
// module chunks = 1